import axios from "axios";
import { API_BASE_URL } from "@/libs/apis/commons";
import { ERROR_CODES } from "@/libs/error/types";

const getTokenMetadataApi = (
  tokenId: string,
  chainId: string,
  contractAddress: string,
) =>
  `${API_BASE_URL}/collections/${chainId}/${contractAddress}/${tokenId}/metadata`;

export const makeApiTokenMetadataCall = async (
  tokenId: string,
  chainId: number,
  contractAddress: string,
  productId: string,
) => {
  return await axios
    .get(getTokenMetadataApi(tokenId, chainId.toString(), contractAddress))
    .then(({ data }) => {
      if (data.metadata !== undefined || data.productId !== productId) {
        const error = new Error("No Metadata or Product Id mismatch");
        //@ts-expect-error
        error.code = ERROR_CODES.NOT_FOUND;
        throw error;
      }
      return data;
    });
};
